import { render, staticRenderFns } from "./FrequentQuestionsCategoryBox.vue?vue&type=template&id=4eea617e&"
import script from "./FrequentQuestionsCategoryBox.js?vue&type=script&lang=js&"
export * from "./FrequentQuestionsCategoryBox.js?vue&type=script&lang=js&"
import style0 from "./FrequentQuestionsCategoryBox.scss?vue&type=style&index=0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports